import { PrintTechnique } from '@midocean/webapps-shared-domain';

export const getTechniqueNameInEnglish = (
  tech: PrintTechnique | undefined
): string => {
  if (!tech) return '';
  return (
    tech?.printTechnique?.nameTranslations
      ?.find((t) => t.language.code === 'en')
      ?.text?.toUpperCase() || ''
  );
};
